module.exports = __webpack_public_path__ + "img/zz1.a2e37b89.png";